// extracted by mini-css-extract-plugin
module.exports = {"cardDiv":"share_cardDiv__3X41T","center":"share_center__ACrPS","modalContent":"share_modalContent__3OtDt","modalBackdrop":"share_modalBackdrop__1yOO6"};